export const transitionTimingFunction = 'cubic-bezier(0.4, 0, 0.2, 1)';

export const colorChangeTransition = 'background, border-color, color, 700ms';
